const QueryDocumentStatus = {
    LOADING: 'Loading',
    TIMED_OUT: 'Timed Out',
    SUCCESS: 'Success',
    NO_RESULTS: 'No results',
    ERROR: 'Error',
};

export default QueryDocumentStatus;
